import React, { useEffect, useState } from "react";
import '../invoice.css';
import moment from "moment";

const StatementOfFacts = ({data, onBack, type}:any) => {
    return (
        <div className="StatementOF">
            <div className="table-header">
                <p className="title">Activity</p>
                <p className="title">Date & Time</p>
                <p className="title">Duration (Hours)</p>
                <p className="title">Remarks</p>
            </div>
            {data?.map((f:any)=>(
                <div className="table-row" key={f?.timestamp}>
                    <p className="value">{f?.activity??"-"}</p>
                    <p className="value">{f?.timestamp??"-"}</p>
                    <p className="value">{f?.duration??"-"}</p>
                    <p className="value">{f?.remarks??"-"}</p>
                </div>
            ))}
        </div>
    )
}

export default StatementOfFacts;